import { createAction } from "@reduxjs/toolkit";

import {
  getFollowersByIdActionTypes,
  getFollowersByIdPortionActionTypes,
  getFollowingsByIdActionTypes,
  getFollowingsByIdPortionActionTypes,
  getMyFollowersActionTypes,
  getMyFollowersPortionActionTypes,
  getMyFollowingsActionTypes,
  getMyFollowingsPortionActionTypes,
  favoriteFollowingActionTypes,
  unfavoriteFollowingActionTypes,
} from "./actionTypes";

export const getMyFollowers = createAction(
  getMyFollowersActionTypes.request,
  (payload) => ({ payload }),
);

export const getMyFollowersSuccess = createAction(
  getMyFollowersActionTypes.success,
  (payload) => ({ payload }),
);

export const getMyFollowersFailure = createAction(
  getMyFollowersActionTypes.failure,
  (error) => ({ payload: error }),
);

export const getMyFollowersPortion = createAction(
  getMyFollowersPortionActionTypes.request,
  (payload) => ({ payload }),
);

export const getMyFollowersPortionSuccess = createAction(
  getMyFollowersPortionActionTypes.success,
  (payload) => ({ payload }),
);

export const getMyFollowersPortionFailure = createAction(
  getMyFollowersPortionActionTypes.failure,
  (payload) => ({ payload }),
);

export const getMyFollowings = createAction(
  getMyFollowingsActionTypes.request,
  (payload) => ({ payload }),
);

export const getMyFollowingsSuccess = createAction(
  getMyFollowingsActionTypes.success,
  (payload) => ({ payload }),
);

export const getMyFollowingsFailure = createAction(
  getMyFollowingsActionTypes.failure,
  (payload) => ({ payload }),
);

export const getMyFollowingsPortion = createAction(
  getMyFollowingsPortionActionTypes.request,
  (payload) => ({ payload }),
);

export const getMyFollowingsPortionSuccess = createAction(
  getMyFollowingsPortionActionTypes.success,
  (payload) => ({ payload }),
);

export const getMyFollowingsPortionFailure = createAction(
  getMyFollowingsPortionActionTypes.failure,
  (payload) => ({ payload }),
);

export const getFollowersById = createAction(
  getFollowersByIdActionTypes.request,
  (payload) => ({ payload }),
);

export const getFollowersByIdSuccess = createAction(
  getFollowersByIdActionTypes.success,
  (payload) => ({ payload }),
);

export const getFollowersByIdFailure = createAction(
  getFollowersByIdActionTypes.failure,
  (payload) => ({ payload }),
);

export const getFollowersByIdPortion = createAction(
  getFollowersByIdPortionActionTypes.request,
  (payload) => ({ payload }),
);

export const getFollowersByIdPortionSuccess = createAction(
  getFollowersByIdPortionActionTypes.success,
  (payload) => ({ payload }),
);

export const getFollowersByIdPortionFailure = createAction(
  getFollowersByIdPortionActionTypes.failure,
  (payload) => ({ payload }),
);

export const getFollowingsById = createAction(
  getFollowingsByIdActionTypes.request,
  (payload) => ({ payload }),
);

export const getFollowingsByIdSuccess = createAction(
  getFollowingsByIdActionTypes.success,
  (payload) => ({ payload }),
);

export const getFollowingsByIdFailure = createAction(
  getFollowingsByIdActionTypes.failure,
  (payload) => ({ payload }),
);

export const getFollowingsByIdPortion = createAction(
  getFollowingsByIdPortionActionTypes.request,
  (payload) => ({ payload }),
);

export const getFollowingsByIdPortionSuccess = createAction(
  getFollowingsByIdPortionActionTypes.success,
  (payload) => ({ payload }),
);

export const getFollowingsByIdPortionFailure = createAction(
  getFollowingsByIdPortionActionTypes.failure,
  (payload) => ({ payload }),
);

export const followersReset = createAction(getMyFollowersActionTypes.reset);

export const favoriteFollowing = createAction(
  favoriteFollowingActionTypes.request,
  (payload) => ({ payload }),
);

export const favoriteFollowingSuccess = createAction(
  favoriteFollowingActionTypes.success,
  (payload) => ({ payload }),
);

export const favoriteFollowingFailure = createAction(
  favoriteFollowingActionTypes.failure,
  (error) => ({ payload: error }),
);

export const favoriteFollowingReset = createAction(
  favoriteFollowingActionTypes.reset,
);

export const unfavoriteFollowing = createAction(
  unfavoriteFollowingActionTypes.request,
  (payload) => ({ payload }),
);

export const unfavoriteFollowingSuccess = createAction(
  unfavoriteFollowingActionTypes.success,
  (payload) => ({ payload }),
);

export const unfavoriteFollowingFailure = createAction(
  unfavoriteFollowingActionTypes.failure,
  (error) => ({ payload: error }),
);
